import React, { useCallback, useMemo } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import UpdateBookedMediaCustomDatesForm from './UpdateBookedMediaCustomDatesForm'

import useManageFormsDrawer from '../../../../../hooks/formHooks/useManageFormsDrawer'

import { getBookedMediaService } from '../../../../../modules/services/mediaOrdersBookings'

import { UPDATE_CUSTOM_FILE_UPLOAD_DATES } from '../../../../../constants/forms'

const UpdateBookedMediaCustomDates = ({ mediaOrderId }) => {
  const { isFormOpen, selectedEditItemId: selectedBookedMediaId } = useManageFormsDrawer({
    formName: UPDATE_CUSTOM_FILE_UPLOAD_DATES
  })
  const queryClient = useQueryClient()

  const { data: bookedMediaData, isLoading: getBookedMediaIsLoading } = useQuery({
    queryKey: ['bookedMedia', selectedBookedMediaId],
    queryFn: async () => getBookedMediaService({ id: selectedBookedMediaId }),
    enabled: isFormOpen && !!selectedBookedMediaId,
    retry: false
  })

  const isFormLoading = useMemo(
    () => !bookedMediaData || getBookedMediaIsLoading,
    [bookedMediaData, getBookedMediaIsLoading]
  )

  const clearBookedMedia = useCallback(() => {
    queryClient.removeQueries(['bookedMedia'])
  }, [queryClient])

  return (
    <FormDrawerWrapper
      formName={UPDATE_CUSTOM_FILE_UPLOAD_DATES}
      title={'Manage custom file upload dates '}
      showOpenButton={false}
      isFormLoading={isFormLoading}
      onAfterFormClose={clearBookedMedia}
    >
      <UpdateBookedMediaCustomDatesForm mediaOrderId={mediaOrderId} bookedMediaData={bookedMediaData} />
    </FormDrawerWrapper>
  )
}

export default UpdateBookedMediaCustomDates
